/**
 * Account Type utilities for handling frontend/backend account type mapping
 */

/**
 * Map backend account type to frontend display value (fallback for old records)
 */
export const mapBackendToFrontend = (backendType) => {
  const mapping = {
    'trial': 'Trial',
    'demo': 'Demo',
    'normal': 'Ongoing',
    'group': 'Consolidated'
  };
  return mapping[backendType?.toLowerCase()] || backendType;
};

/**
 * Map frontend account type to backend value
 */
export const mapFrontendToBackend = (frontendType) => {
  const mapping = {
    'Trial': 'trial',
    'Trial Demo': 'normal',
    'Unpublished': 'normal',
    'Published': 'normal',
    'Platform': 'normal',
    'Onboarding': 'normal',
    'Ongoing': 'normal',
    'Consolidated': 'group',
    'Aggregated': 'group',
    'Demo': 'demo'
  };
  return mapping[frontendType] || frontendType?.toLowerCase();
};

/**
 * Get the display account type from customer data
 * Prioritizes frontend_account_type if available, otherwise maps from backend customer_type
 *
 * @param {Object} customer - Customer object with frontend_account_type and/or customer_type
 * @returns {string} - The account type to display
 */
export const getDisplayAccountType = (customer) => {

  // Use frontend_account_type if available (new records)
  if (customer?.frontend_account_type) {
    return customer.frontend_account_type;
  }

  // Fallback to mapping backend customer_type (old records)
  if (customer?.customer_type) {
    const mapped = mapBackendToFrontend(customer.customer_type);
    return mapped;
  }

  return '';
};

/**
 * Capitalize first letter of a string
 */
export const capitalizeType = (type) => {
  if (!type) return '';
  return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
};
